import Menu from '../../../components/Menu/Menu';
import './Minigames.scss';

export default function Minigames() {
    return (
        <div id='minigames'>
            <div className='centered-container'>
                <Menu title="Minigames" options={[
                    { name: 'Bingo', path: '/misc/minigames/bingo' },
                    { name: 'Plates', path: '/misc/minigames/plates', roles: 'developer' },
                    { name: 'PartyFun', path: '/misc/minigames/burrunitos', roles: 'developer' },
                    { name: 'SetasYPorros', path: '/misc/minigames/setasyporros', roles: 'developer' },
                    { name: 'Go Back', path: '/..' },
                ]} />
            </div>
        </div>
    );
}